import React, { useState, useEffect } from 'react';

import { Dropdown } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, getObjectPropertyValue, isArrayNotEmpty, isNumberValid, isStringTrimNotEmpty } from "functions";

export function useCompanyInputs(props) {
    // Props
    
    const {
        isEditing,
        billingSetup,
        isFormSubmissionAttempted,
        isDraft,
        
        comIdList,
        accountCodeList,
        // dealerCodeList,
        // salesPersonCodeList,
        fullAgentCodeList,

        // Functions
        getFullAgentCodeList = () => {},
    } = props;

    let companyId_original = getObjectPropertyValue(billingSetup, "CompanyId");
    let accountCode_original = getObjectPropertyValue(billingSetup, "AccountCode");
    let dealerCode_original = getObjectPropertyValue(billingSetup, "DealerCode");
    let salesPersonCode_original = getObjectPropertyValue(billingSetup, "SalesPersonCode");


    // States
    const [companyId, setCompanyId] = useState(companyId_original);
    const [accountCode, setAccountCode] = useState(accountCode_original);
    const [isTypingAccountCode, setIsTypingAccountCode] = useState();
    const [dealerCode, setDealerCode] = useState(dealerCode_original);
    const [salesPersonCode, setSalesPersonCode] = useState(salesPersonCode_original);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);
    const [dealerCodeList, setDealerCodeList] = useState();
    const [salesPersonCodeList, setSalesPersonCodeList] = useState();


    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            companyId === companyId_original &&
            accountCode === accountCode_original &&
            dealerCode === dealerCode_original &&
            salesPersonCode === salesPersonCode_original
        );

        let isChangedFromEmpty = (
            companyId || accountCode || dealerCode || salesPersonCode
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);    
    }, [
        companyId, accountCode, dealerCode, salesPersonCode
    ]);

    // Get Dealer and Sales Person Codes FULL list (Not just from existing setups)
    useEffect(() => {
        getFullAgentCodeList();
    }, []);

    useEffect(() => {
        if(fullAgentCodeList){
        const tempDealerCode = fullAgentCodeList.partnerList;
        const tempSalesPersonCode = fullAgentCodeList.salesRepList;
      
        if (isArrayNotEmpty(tempDealerCode)) {
            let dealerList = []
            tempDealerCode.map((aDealerCode) => {
                if (aDealerCode.indexOf("3100-") != -1) {
                    dealerList.push(aDealerCode);
                }
            })
            setDealerCodeList(dealerList);
        }

        if (isArrayNotEmpty(tempSalesPersonCode)) {
            let salesPersonList = [];
            tempSalesPersonCode.map((aSalesPerson) => {

                salesPersonList.push(aSalesPerson);
            })
            setSalesPersonCodeList(salesPersonList);
        }
    }
    }, [fullAgentCodeList]);

    // Display
    let display = (
        <div className={"recursiveBillingSetupAccountUpdate-company d-flex flex-wrap"}>
            {/* Company Id */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-companyId"}
                label={"Company ID"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-companyId-input"}

                options={comIdList}
                selectedValue_default={companyId}
                onChange={setCompanyId}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isInputDigitOnly isSearchable
                isInputValueTrim_onChange

                isDisabled={isEditing && !isDraft}
            />

            {/* Account Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-accountCode"}
                label={"Account Code"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-accountCode-input"}

                options={accountCodeList}
                selectedValue_default={accountCode}
                onChange={(value) => {
                    setIsTypingAccountCode(true);
                    setAccountCode(value);
                }}
                onBlur={() => {
                    setIsTypingAccountCode(false);
                }}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable

                isDisabled={isEditing && !isDraft}
            />

            {/* Dealer Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-dealerCode"}
                label={"Dealer Code"}

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-dealerCode-input"}

                options={convertArrayToDropdownArrayFormat(dealerCodeList)}
                selectedValue_default={dealerCode}
                onChange={setDealerCode}

                isSearchable
                isDisabled={isEditing && !isDraft}
            />

            {/* Sales Person Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-salesPersonCode"}
                label={"Sales Person Code"}

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-salesPersonCode-input"}

                options={convertArrayToDropdownArrayFormat(salesPersonCodeList)}
                selectedValue_default={salesPersonCode}
                onChange={setSalesPersonCode}

                isSearchable
                isDisabled={isEditing && !isDraft}
            />
        </div>
    );

    let isEveryInputValid = (
        isNumberValid(companyId) &&
        isStringTrimNotEmpty(accountCode)
        // isStringTrimNotEmpty(dealerCode) &&
        // isStringTrimNotEmpty(salesPersonCode) &&
    );

    let companyDetails = {
        CompanyId: companyId,
        AccountCode: accountCode,
        DealerCode: isStringTrimNotEmpty(dealerCode)? dealerCode:"",
        SalesPersonCode: isStringTrimNotEmpty(salesPersonCode)? salesPersonCode:"",
    }

    return {
        companyId, companyDetails,
        isTypingAccountCode,

        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}